import React, { Component } from 'react';
import { Line } from 'react-chartjs-2';
import YearPicker from "react-year-picker";
import api from '../api/index.js';

const colors = ['rgba(255,0,0,1)', 'rgba(0,255,0,1)', 'rgba(0,0,255,1)'];

const mystyle = {
    zIndex: 20,
    width: 'fit-content'
};

const datas = {
    Listrik: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
}

const dataUsage = {
    Listrik: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
}

const getItemData = (label, color, data) => {
    const item = {
        label: label,
        fill: false,
        lineTension: 0.1,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: color,
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: color,
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: color,
        pointHoverBorderColor: 'rgba(220,220,220,1)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: data
    }

    return item;
}

const getData = (datasets) => {
    const data = {
        labels: ['Januari', 'Febuari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
        datasets: datasets
    };
    return data
}

export default class LineDemo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: getData([]),
            dataUsage: getData([]),
            year: new Date().getFullYear() - 1
        };

        this.chart = React.createRef();
        this.chartUsage = React.createRef();
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputUsageChange = this.handleInputUsageChange.bind(this);
        this.changeYearPicker = this.changeYearPicker.bind(this);
        this.iniFungsi = this.iniFungsi.bind(this);
    }

    /* React Lifecycle function to get initial data from database (Masih blom diintegrasiin sama database) */
    componentDidMount = async () => {
        const checked = [];
        const thisData = getData(checked);

        this.setState({
            data: thisData
        });

        this.setState({
            dataUsage: thisData
        });

        var criteria;

        /* Mendapatkan nama-nama gedung */
        var criteria = {
            "building": "All",
            "year": this.state.year
        };

        // COMMENT && UNCOMMENT
        // await api.getBuildingByLocation(criteria).then(res => {
        //     console.log(res.data.data.map(x => x["name_building"])); //get building names only
        // })

        /* Mendapatkan data-data untuk tabel */
        // console.log("Get data for table");
        // console.log("Get listrik data");

        // COMMENT && UNCOMMENT
        // await api.getAirForTable(criteria).then(res => {
        //     console.log(res.data.data);
        // })

        // console.log("Get air data");

        // criteria = {
        //     "location": "Kampus Ganesa",
        //     "month": "11",                  
        //     "year": "2019",
        //     "start": 0, // start at what index
        //     "size": 50  
        // };

        // COMMENT && UNCOMMENT
        // await api.getAirForTable(criteria).then(res => {
        //     console.log(res.data.data);
        // })

        // console.log("Get data for graph line");

        // criteria = {
        //     "building": "101 Kantor FTSL",
        //     "year": "2019"
        // }

        // COMMENT && UNCOMMENT
        await api.getListrikForGraphLine(criteria).then(res => {
            // for(var i=0; i < res.data.data.length; ++i){
            //     var bulan = res.data.data[i].bulan.split("-")[1];
            //      ;
            // }
            res.data.data.map(x => {
                datas.Listrik[parseInt(x["bulan"].split("-")[1] - 1)] += x["jumlah tagihan (Rp)"];
                dataUsage.Listrik[parseInt(x["bulan"].split("-")[1] - 1)] += x["tarif/daya (VA)"];
            });

            // console.log(res.data.data.map(x => x["jumlah tagihan (Rp)"]));
            // console.log(res.data.data.map(x => x["tarif/daya (VA)"]));
            // console.log(res.data.data.map(x => x["bulan"]));
        })

        // Untuk air, pakai getAirForGraphLine dan data criteria-nya sama

        // console.log("Get data for graph bar");

        // criteria = {
        //     "location": "Kampus Ganesa",
        //     "month": "11",
        //     "year": "2019"
        // }

        // COMMENT && UNCOMMENT
        // await api.getListrikForGraphBar(criteria).then(res => {
        //     console.log(res.data.data.map(x => x["jumlah tagihan (Rp)"]));
        //     console.log(res.data.data.map(x => x["tarif/daya (VA)"]));
        //     console.log(res.data.data.map(x => x["name_building"]));
        // })

        // Untuk air, pakai getAirForGraphBar dan data criteria-nya sama
    }

    /**
     * Handle input change from pengeluaran checkbox
     *
     * @return None
     */
    handleInputChange = async () => {
        let iItem = 0;
        const checked = [];
        var inputElements = document.getElementsByClassName('categoryCheckbox');
        for (var i = 0; inputElements[i]; ++i) {
            if (inputElements[i].checked) {
                let data;
                data = datas[inputElements[i].value];
                // if (this.state.year % 2 == 0) {
                //     data = datas[inputElements[i].value];
                // } else {
                //     data = datas2[inputElements[i].value];
                // }
                const color = colors[iItem];
                const item = getItemData(inputElements[i].value, color, data);
                checked.push(item);
                iItem++;
            }
        }
        const thisData = getData(checked);

        this.setState({
            data: thisData
        });
    }

    handleInputUsageChange() {
        let iItem = 0;
        const checked = [];
        var inputElements = document.getElementsByClassName('usageRadioButton');
        for (var i = 0; inputElements[i]; ++i) {
            if (inputElements[i].checked) {
                const data = dataUsage[inputElements[i].value];
                const color = colors[iItem];
                const item = getItemData(inputElements[i].value, color, data);
                checked.push(item);
                iItem++;
            }
        }
        const thisData = getData(checked);

        this.setState({
            dataUsage: thisData
        });
    }

    iniFungsi(year, value) {
        //     console.log('datas')
        //     console.log(datas)
        //     console.log('end datas')

        // console.log('datas2')
        // console.log(datas2)
        // console.log('end datas2')
        // if (year % 2 == 0) {
        return datas[value];
        // } else {
        // return datas2[value];
        // }
    }

    changeYearPicker(value) {
        let iItem = 0;
        const checked = [];
        var inputElements = document.getElementsByClassName('categoryCheckbox');
        for (var i = 0; inputElements[i]; ++i) {
            if (inputElements[i].checked) {
                const data = this.iniFungsi(value, inputElements[i].value);
                const color = colors[iItem];
                const item = getItemData(inputElements[i].value, color, data);
                checked.push(item);
                iItem++;
            }
        }
        const thisData = getData(checked);

        this.setState({
            year: value,
            data: thisData
        });
    }

    /* React Lifecycle render function */
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ml-auto wrapper-year-picker" style={mystyle}>
                            <YearPicker className="ml-auto" onChange={this.changeYearPicker} />
                        </div>
                    </div>

                    <div className="col-md-12">
                        <h3>Tahun {this.state.year}</h3>
                    </div>

                    <div className="col-md-6">
                        <h4>Data pengeluaran</h4>
                        <Line ref={this.chart} data={this.state.data} options={{}} />
                        <div className="row">
                            <div className="col-md-6">
                                <label>
                                    <input
                                        name="isGoing"
                                        type="checkbox"
                                        value="Listrik"
                                        className="categoryCheckbox mr-2"
                                        onChange={this.handleInputChange} />
                                    Listrik
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <h4>Data pengunaan</h4>
                        <Line ref={this.chartUsage} data={this.state.dataUsage} options={{}} />
                        <div className="row">
                            <div className="col-md-6">
                                <label>
                                    <input
                                        name="usage"
                                        type="radio"
                                        value="Listrik"
                                        className="mr-2 usageRadioButton"
                                        onChange={this.handleInputUsageChange} />
                                    Listrik
                                </label>
                            </div>
                        </div>

                    </div>


                </div>
            </div>
        );
    }
}